<template>
  <!-- 人员详情 -->
  <div class="personnelDetail">
    <h-anchor class="anchor" :idList="idList">
      <el-form
        :disabled="status === 3"
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="130px"
        class="userForm"
        :status-icon="false"
      >
        <div style="text-align: center">
          <el-upload
            :action="'/api/hz-smart-community/sys/file/upload'"
            list-type="picture-card"
            :headers="{
              token: token,
            }"
            :show-file-list="false"
            :on-success="handlePictureCardPreview"
            :limit="1"
          >
            <el-icon v-if="!ruleForm.imageUrl"><plus /></el-icon>
            <img v-else :src="imgURL + ruleForm.imageUrl" />
          </el-upload>
        </div>
        <div id="one">
          <div class="formTitle"><span></span>基本信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="国籍" prop="nationality">
                <h-selectcode
                  type="countryType"
                  v-model="ruleForm.nationality"
                  placeholder="国籍"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="ruleForm.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <h-selectcode
                  type="sex"
                  v-model="ruleForm.sex"
                  placeholder="性别"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民族" prop="">
                <h-selectcode
                  type="nationType"
                  v-model="ruleForm.nation"
                  placeholder="民族"
                ></h-selectcode>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                label="证件号码"
                :prop="ruleForm.cardType == '0' ? 'cardNumber' : ''"
                class="cardTypeItemStyle"
              >
                <el-input v-model="ruleForm.cardNumber" placeholder="证件号码">
                  <!-- <template #prepend> -->
                  <!-- <el-form-item label="证件号码" prop="cardType"> -->
                  <!-- <h-selectcode
                  type="card_type"
                  v-model="ruleForm.cardType"
                  placeholder="证件号码"
                ></h-selectcode> -->
                  <!-- </el-form-item> -->
                  <!-- </template> -->
                </el-input>
                <h-selectcode
                  type="card_type"
                  v-model="ruleForm.cardType"
                  :clearable="true"
                  placeholder="证件号码"
                  class="cardTypeStyle"
                ></h-selectcode>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  v-model="ruleForm.birthday"
                  placeholder="出生日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="婚姻状况" prop="marital">
                <h-selectcode
                  type="marital_type"
                  v-model="ruleForm.marital"
                  placeholder="婚姻状况"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="telphone">
                <el-input
                  v-model="ruleForm.telphone"
                  placeholder="电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文化程度" prop="education">
                <h-selectcode
                  type="educationType"
                  v-model="ruleForm.education"
                  placeholder="文化程度"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="strengthShow">
              <el-form-item label="力量类型" prop="strengthGroupId">
                <h-selectcode
                  type="strengthType"
                  v-model="ruleForm.strengthGroupId"
                  placeholder="力量类型"
                ></h-selectcode>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div id="two">
          <div class="formTitle"><span></span>实际居住地址</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="与房主关系" prop="relation">
                <h-selectcode
                  type="houseRelationType"
                  v-model="ruleForm.relation"
                  placeholder="与房主关系"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="详细地址" prop="houseId">
                <el-cascader
                  ref="cascaderRef"
                  v-model="ruleForm.houseId"
                  @change="cascaderchange"
                  :props="{
                    value: 'id',
                    label: 'name',
                  }"
                  :options="unitNameoptions"
                  placeholder="详细地址"
                  clearable
                >
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div id="three">
          <div class="formTitle"><span></span>户籍地址</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="市省县（区）" prop="">
                <el-cascader
                  v-model="ruleForm.registerId"
                  :options="houseRentTypeList"
                  :props="{ value: 'districtId', label: 'name' }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区划内详细地址" prop="registerDetail">
                <el-input
                  v-model="ruleForm.registerDetail"
                  placeholder="区划内详细地址"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div id="four" style="height: 550px">
          <div class="formTitle"><span></span>其他信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="职业" prop="">
                <el-input v-model="ruleForm.job" placeholder="职业"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职业类别" prop="jobType">
                <h-selectcode
                  type="job_type"
                  v-model="ruleForm.jobType"
                  placeholder="职业类别"
                ></h-selectcode>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="人户一致标识" prop="code">
                <h-selectcode
                  type="householdType"
                  v-model="ruleForm.code"
                  placeholder="人户一致标识"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人口管理类别" prop="prisonType">
                <h-selectcode
                  type="populationType"
                  v-model="ruleForm.prisonType"
                  placeholder="人口管理类别"
                ></h-selectcode>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员标签" prop="label">
                <h-selectcode
                  type="prison_label"
                  v-model="ruleForm.label"
                  placeholder="人员标签"
                ></h-selectcode>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="">
                <el-input
                  v-model="ruleForm.comment"
                  placeholder="备注"
                  show-word-limit
                  type="textarea"
                />
                <!-- <el-input v-model="ruleForm.comment" placeholder="备注"> </el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </h-anchor>

    <div v-if="status !== 3" class="bottomCenter">
      <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
  onMounted,
} from "vue";
import util from "@util/js";
import Validate from "@/utils/validate.js";
import { ElMessage } from "element-plus";
import {
  saveQuery as realPopulation,
  areaselectList,
  updateQuery,
  infoQuery,
} from "@/api/realPopulation/realPopulation";
import { prisonsave } from "@/api/communityCare/communityCareApi.js";
import { strengthsave, strengthupdate } from "@/api/threeSolid/threeSolid.js";
import { Plus } from "@element-plus/icons-vue";
import _ from "lodash";
import { infoSelect } from "@/api/constant";
import moment from "moment";

export default defineComponent({
  name: "PersonnelDetail",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    addAndAdd: {
      type: Boolean,
      default: false,
    }, //false正常添加实有人口  true 实有力量、关怀人员，添加先加人再加入力量
    strengthShow: {
      type: Boolean,
      default: false,
    }, //false正常添加实有人口  true 实有力量添加先加人再加入力量
    careLibrary: {
      type: Boolean,
      default: false,
    }, //false正常添加实有人口  true 关怀人员添加先加人再加入力量
    careLibraryCareId: {
      type: String,
      default: "",
    }, //false正常添加实有人口  true 关怀人员添加先加人再加入力量
    form: {
      type: Object,
      default: () => ({}),
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    currentRegion: {
      type: Object,
      default: () => ({}),
    }, // 当前区域信息
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "userSubmit"],
  setup(props, context) {
    const ruleFormRef = ref(null);
    const cascaderRef = ref(null);
    const validate = new Validate(ruleFormRef.value);

    const state = reactive({
      imgURL: window.imgURL,
      token: localStorage.getItem("token"),
      defaultPassword: "kzga110",
      formVisible: false,
      idList: [
        { name: "基本信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "实际居住地址", id: "two", icon: "icon-invite" },
        { name: "户籍地址", id: "three", icon: "icon-shuidianbiaoguanli" },
        { name: "其他信息", id: "four", icon: "icon-shuidianbiaoguanli" },
      ],
      show: 0,
      passwordType: 1,

      ruleForm: {
        nationality: "43", // 国籍
        name: "", // 姓名
        sex: "1", // 性别
        birthday: "", // 出生日期
        cardNumber: "", // 证件号码
        cardType: "0", // 证件类型
        nation: "1", // 民族
        marital: "0", // 婚姻状况
        telphone: "", // 电话
        education: "", // 文化程度
        relation: "", // 与房主关系
        job: "", // 职业
        jobType: "", // 职业类别
        code: "1", // 人户一致标识
        prisonType: "11", // 人口管理类别
        comment: "", // 备注,
        houseId: "",
        imageUrl: "",
        registerDetail: "",
        registerId: "",
        strengthGroupId: "", // 力量类型
      },
      houseRentTypeList: [], // 居住现状

      ruleFormBack: {},
      rules: {
        nationality: [
          {
            required: true,
            message: "请选择国籍",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],

        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "blur",
          },
        ],
        marital: [
          {
            required: true,
            message: "请选择婚姻状况",
            trigger: "blur",
          },
        ],
        prisonType: [
          {
            required: true,
            message: "请选择人口管理类别",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请选择人户一致标识",
            trigger: "blur",
          },
        ],
        unitCode: [
          {
            required: true,
            message: "请选择省市（县）区",
            trigger: "blur",
          },
        ],
        houseId: [
          {
            required: true,
            message: "地址请具体到房屋",
            trigger: "blur",
          },
        ],
        relation: [
          {
            required: true,
            message: "请选择与房主关系",
            trigger: "blur",
          },
        ],
        registerDetail: [
          {
            required: true,
            message: "请输入区划内详细地址",
            trigger: "blur",
          },
        ],
        jobType: [
          {
            required: true,
            message: "请选择职业类别",
            trigger: "blur",
          },
        ],
        education: [
          {
            required: true,
            message: "请选择文化程度",
            trigger: "blur",
          },
        ],
        strengthGroupId: [
          {
            required: true,
            message: "请选择力量类型",
            trigger: "blur",
          },
        ],
        telphone: [
          {
            required: true,
            message: "输入手机号",
            trigger: "blur",
          },
        ],
      },
      unitNameoptions: [],
      unitNameoptionsNode: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    if (props.status === 1) {
      state.rules.cardNumber = [
        {
          required: true,
          validator: validate.iDCard,
          trigger: "blur",
        },
      ];
      state.rules.telphone = [
        {
          required: true,
          validator: validate.tel,
          trigger: "blur",
        },
      ];
    } else if (props.status === 2) {
      state.rules.cardNumber = [
        {
          required: true,
          validator: validate.iDCards,
          trigger: "blur",
        },
      ];
      state.rules.telphone = [
        {
          required: true,
          validator: validate.tels,
          trigger: "blur",
        },
      ];
    }
    // 初始化表单
    const initForm = async () => {
      if (props.status !== 1) {
        state.passwordType = 2;
      }
      ruleFormRef.value && ruleFormRef.value.resetFields();
      if (props.status === 2 || props.status === 3) {
        const res = await infoQuery(
          props.form.prisonId || props.form.prisonInfo.prisonId
        );
        console.log(props.row, 5555555);
        state.ruleForm.strengthGroupId = props.row.strengthGroupId;
        const form = { ...state.ruleForm, ...res.prisonInfo };
        form.houseId =
          res.prisonInfo.houseId && res.prisonInfo.houseId.toString();
        state.ruleForm = _.cloneDeep(form);
      }
    };
    // 监听
    watch(
      () => state.formVisible,
      (v) => {
        console.log(state.ruleForm);
        console.log(props.status);

        initForm();
      }
    );
    watch(
      () => state.ruleForm.cardNumber,
      () => {
        if (
          (state.ruleForm.cardNumber.split("").length === 18 ||
            state.ruleForm.cardNumber.split("").length === 15) &&
          state.ruleForm.cardNumber.indexOf("*") === -1
        ) {
          state.ruleForm.birthday = moment(
            util.birthdayFromCardId(state.ruleForm.cardNumber)
          );
          console.log(state.ruleForm.birthday, 6666);
        }
      }
    );
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    const methods = {
      async infoSelectAxios() {
        const params = {
          type: 0,
        };
        const res = await infoSelect(params);
        const rootPid = res.top.map((item) => {
          return item.toString();
        });
        const options = { pid: "parentId", id: "id", rootPid };
        const treeData = util.arrayToTree(res.list, options);
        state.unitNameoptionsNode = res.list;
        state.unitNameoptions = treeData;
      },
      async submitForm(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            let res;
            if (state.ruleForm.registerId) {
              state.ruleForm.registerId =
                state.ruleForm.registerId[state.ruleForm.registerId.length - 1];
            }

            if (props.status === 1) {
              const form = _.cloneDeep(state.ruleForm);
              // form.houseId =
              //   state.ruleForm.houseId[state.ruleForm.houseId.length - 1];
              if (!props.addAndAdd) {
                res = await realPopulation(form);
                context.emit("userSubmitOver", res.prisonId);
              } else {
                //实有力量新建力量时。需要先加人再走绑定力量接口
                const resRealPopulation = await realPopulation(form);
                if (props.strengthShow) {
                  const params = {
                    prisonId: resRealPopulation.prisonId, // 人id
                    regionId: props.currentRegion.id, // 父id
                    strengthGroupId: state.ruleForm.strengthGroupId, // 对应社区下面的id
                  };
                  res = await strengthsave(params);
                } else if (props.careLibrary) {
                  let prisonIds = [resRealPopulation.prisonId];
                  const params = {
                    prisonIds,
                    careId: props.careLibraryCareId,
                  };
                  res = await prisonsave(params);
                }
              }
            } else if (props.status === 2) {
              const from = JSON.parse(JSON.stringify(state.ruleForm));
              if (from.cardNumber.indexOf("********") !== -1) {
                delete from.cardNumber;
              }
              if (from.telphone.indexOf("****") !== -1) {
                delete from.telphone;
              }
              const resUpdateQuery = await updateQuery(from);
              const params = {
                strengthId: props.row.strengthId,
                prisonId: state.ruleForm.prisonId, // 人id
                regionId: props.currentRegion.id, // 父id
                strengthGroupId: state.ruleForm.strengthGroupId, // 对应社区下面的id
              };
              res = await strengthupdate(params);
            }
            if (res.code === 0) {
              ElMessage.success(props.status === 1 ? "添加成功" : "修改成功");
              context.emit("submit");
              state.formVisible = false;
              context.emit("update:modelValue", state.formVisible);
            }
          } else {
            console.log("error submit!");
            return false;
          }
        });
      },
    };
    methods.infoSelectAxios();
    const handlePictureCardPreview = (file) => {
      console.log(file);
      state.ruleForm.imageUrl = file.data.fileUrl;
    };
    // 地址
    const regist = async () => {
      const res = await areaselectList();
      const newlist = res.districtList;
      const options = { pid: "parentId", id: "districtId", rootPid: 100000 };
      state.houseRentTypeList = util.arrayToTree(newlist, options); // 数组,参数
    };
    regist();
    // 详细地址的判断
    const cascaderchange = (val) => {
      if (val) {
        const value = val[val.length - 1];
        state.ruleForm.houseId = "";
        state.unitNameoptionsNode.forEach((item) => {
          if (item.id === value) {
            if (item.type === 7) {
              state.ruleForm.houseId = item.id;
            } else {
              // state.ruleForm.houseId = val;
              // ElMessage({
              //   type: "warning",
              //   message: "请具体选择到房屋",
              // });
            }
          }
        });
      }
    };

    return {
      ...refData,
      ...methods,
      cascaderchange,
      handlePictureCardPreview,
      ruleFormRef,
      cascaderRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.personnelDetail {
  // display: flex;
  max-height: 600px;
  overflow: auto;
  .anchor {
    max-height: 550px;
  }
  .userForm {
    width: 100%;

    padding: 20px;
    img {
      width: 100%;
      height: 100%;
    }
    :deep(.el-upload--picture-card) {
      width: 100px;
      height: 100px;
      font-size: 16px !important;
      .el-icon {
        margin-top: 36px !important;
      }
    }
    :deep(input) {
      // background-color: transparent !important;
      // height: 29px !important;
      box-sizing: border-box !important;
    }
    :deep(.el-select) {
      width: 100%;
    }
    :deep(.el-input) {
      width: 100%;
    }
    // :deep(.el-input__inner) {
    //   background: #fff !important;
    //   height: 29px !important;
    // }
    :deep(.el-cascader) {
      width: 100%;
    }
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
  .margLeftLabel {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .bottomCenter {
    display: flex;
    justify-content: center;
    border-top: 1px solid;
    border-color: #eee;
    padding-top: 16px;
  }
  :deep(.el-input-group__prepend) {
    width: 150px;
    height: 100%;
    padding-right: 0px !important;
    box-sizing: border-box;
    .HSelectcode {
      width: 115% !important;
    }
  }
  .h-input {
    height: 29px !important;
    :deep(.select-trigger) {
      height: 100%;
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
  }
  .cardTypeItemStyle {
    /deep/.el-form-item__content {
      flex-wrap: nowrap;
    }

    .cardTypeStyle {
      width: 65%;
    }
  }
  .left {
    position: fixed;
    top: 162px;
    ul {
      .item {
        box-shadow: 0 0 2px;
        cursor: pointer;
        margin: 30px 0;
        border: solid 1px #dcdfe6;
        width: 110px;
        line-height: 50px;
        text-align: center;
        display: flex;
        flex-direction: column;
      }
      .item1 {
        box-shadow: 0 0 2px;
        color: #3a74fb;
        cursor: pointer;
        margin: 30px 0;
        border: solid 1px #3a74fb;
        border-left: solid 5px #3a74fb;
        width: 110px;
        line-height: 50px;
        text-align: center;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .right {
    overflow: auto;
  }
}
</style>
